import APIService from '@/services/api-service'
const resource = '/refund/fda'

class FdaService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public getFDAs (clientId: number) {
    return this.connector.get(`${resource}/${clientId}`)
  }

  public getRefundFDA (refundId: number) {
    return this.connector.get(`${resource}/${refundId}/refund-details`)
  }

  public createRefund (refunds: any) {
    return this.connector.post(`${resource}/create`, refunds)
  }

  public updateRefund (refunds: any) {
    return this.connector.put(`${resource}/update`, refunds)
  }
}

export default new FdaService()
